import React, { useEffect, useState } from "react";
import { Link, useLocation, useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";

export default function PaymentResult() {
  const location = useLocation();
  const [params] = useSearchParams();
  const isCancel = location.pathname.includes("cancel");
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState(isCancel ? "cancel" : "checking");
  const [attempts, setAttempts] = useState(0);

  useEffect(() => {
    if (isCancel || !sessionId) return;
    let active = true;
    const poll = async () => {
      if (attempts > 8) { if (active) setStatus("timeout"); return; }
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (!active) return;
        if (data.payment_status === "paid") { setStatus("paid"); return; }
        if (["expired", "failed"].includes(data.payment_status)) { setStatus("failed"); return; }
        setTimeout(() => setAttempts((a) => a + 1), 2000);
      } catch {
        if (active) setTimeout(() => setAttempts((a) => a + 1), 2000);
      }
    };
    poll();
    return () => { active = false; };
  }, [sessionId, attempts, isCancel]);

  const view = {
    checking: { icon: <Loader2 className="h-12 w-12 text-primary animate-spin" />, title: "Confirmando pagamento…", sub: "Aguarde um instante." },
    paid: { icon: <CheckCircle2 className="h-12 w-12 text-emerald-500" />, title: "Pagamento confirmado!", sub: "Seu plano foi ativado. Aproveite a plataforma." },
    failed: { icon: <XCircle className="h-12 w-12 text-red-500" />, title: "Pagamento não concluído", sub: "Nenhuma cobrança foi efetuada." },
    timeout: { icon: <Loader2 className="h-12 w-12 text-amber-500" />, title: "Ainda processando", sub: "Isso pode levar alguns minutos. Verifique novamente no painel." },
    cancel: { icon: <XCircle className="h-12 w-12 text-muted-foreground" />, title: "Pagamento cancelado", sub: "Você pode escolher um plano quando quiser." },
  }[status];

  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-6">
      <div className="max-w-sm w-full text-center space-y-6 animate-float-up">
        <div className="flex justify-center">{view.icon}</div>
        <div className="space-y-1">
          <h1 className="font-heading text-2xl font-bold">{view.title}</h1>
          <p className="text-muted-foreground text-sm">{view.sub}</p>
        </div>
        <Button asChild className="w-full" data-testid="back-dashboard">
          <Link to="/dashboard">Ir para o painel</Link>
        </Button>
      </div>
    </div>
  );
}
